import gql from 'graphql-tag';

import albumFolderFunnelData from '../fragments/albumFolderFunnelData';

export const getAlbumMembershipGroupFunnelDataQuery = gql`
  query getAlbumMembershipGroupFunnelDataQuery($id: RecordID!) {
    albumMembershipGroup(id: $id, root_groups_only: true) {
      id
      album {
        id
        root_album_folder {
          ...albumFolderFunnelData
        }
      }
      album_folder {
        ...albumFolderFunnelData
      }
    }
  }
  ${albumFolderFunnelData}
`;
